import React from 'react'
import GetApp from '@material-ui/icons/GetApp'

const Download = props => <GetApp {...props} />
export default Download
